import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOPruefZyklusListStatus: 'idle',
    loadTOPruefZyklusListError: undefined as any,
    loadTOPruefZyklusListLastArgs: undefined as any,
    loadTOPruefZyklusStatus: 'idle',
    loadTOPruefZyklusError: undefined as any,
    saveTOPruefZyklusStatus: 'idle',
    saveTOPruefZyklusError: undefined as any,
    deleteTOPruefZyklusStatus: 'idle',
    deleteTOPruefZyklusError: undefined as any,

    tOPruefZyklusList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOPruefZyklusList = createAsyncThunk('toPruefZyklusSlice/loadTOPruefZyklusList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toPruefZyklusSlice.loadTOPruefZyklusListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristopruefzyklus/?action=gte&TOID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOPruefZyklusListStatus } = getState().toPruefZyklusSlice
        return loadTOPruefZyklusListStatus !== 'pending'
    }
})

export const loadTOPruefZyklus = createAsyncThunk('toPruefZyklusSlice/loadTOPruefZyklus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristopruefzyklus/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOPruefZyklusStatus } = getState().toPruefZyklusSlice
        return loadTOPruefZyklusStatus !== 'pending'
    }
})

export const saveTOPruefZyklus = createAsyncThunk('toPruefZyklusSlice/saveTOPruefZyklus', async ({ tOPruefZyklus }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tOPruefZyklus?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristopruefzyklus/${ tOPruefZyklus?.HDR_ID }/`,
            prepareData(tOPruefZyklus),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristopruefzyklus/`,
            prepareData(tOPruefZyklus),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOPruefZyklusStatus } = getState().toPruefZyklusSlice
        return saveTOPruefZyklusStatus !== 'pending'
    }
})

export const deleteTOPruefZyklus = createAsyncThunk('toPruefZyklusSlice/deleteTOPruefZyklus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristopruefzyklus/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOPruefZyklusStatus } = getState().toPruefZyklusSlice
        return deleteTOPruefZyklusStatus !== 'pending'
    }
})

const TOPruefZyklusSlice = createSlice({
    name: 'toPruefZyklusSlice',
    initialState,
    reducers: {
        resetloadTOPruefZyklusListError: (state) => {
            state.loadTOPruefZyklusListError = undefined
        },
        resetloadTOPruefZyklus: (state) => {
            state.formItem = undefined
            state.loadTOPruefZyklusError = undefined
        },
        resetloadTOPruefZyklusError: (state) => {
            state.loadTOPruefZyklusError = undefined
        },
        resetsaveTOPruefZyklus: (state) => {
            state.formItem = undefined
            state.saveTOPruefZyklusError = undefined
        },
        resetsaveTOPruefZyklusError: (state) => {
            state.saveTOPruefZyklusError = undefined
        },
        resetdeleteTOPruefZyklusError: (state) => {
            state.deleteTOPruefZyklusError = undefined
        },
        removeFromTOPruefZyklusListById: (state, action) => {
            state.tOPruefZyklusList = state.tOPruefZyklusList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOPruefZyklusListByIds: (state, action) => {
            state.tOPruefZyklusList = state.tOPruefZyklusList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOPruefZyklusList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOPruefZyklusListStatus = 'preloaded'
            state.loadTOPruefZyklusListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOPruefZyklusList = []
            state.loadTOPruefZyklusListStatus = 'idle'
            state.loadTOPruefZyklusListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOPruefZyklusList.pending, (state) => {
            state.loadTOPruefZyklusListStatus = 'pending'
            state.loadTOPruefZyklusListError = undefined
        })
        builder.addCase(loadTOPruefZyklusList.fulfilled, (state, action) => {
            state.loadTOPruefZyklusListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOPruefZyklusListLastArgs = action.payload.args

            {
                state.tOPruefZyklusList = action.payload.data

            }
        })
        builder.addCase(loadTOPruefZyklusList.rejected, (state, action) => {
            state.loadTOPruefZyklusListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOPruefZyklusListError = action.error.message
            } else {
                state.loadTOPruefZyklusListError = action.payload
            }
        })

        builder.addCase(loadTOPruefZyklus.pending, (state) => {
            state.loadTOPruefZyklusStatus = 'pending'
            state.loadTOPruefZyklusError = undefined
        })
        builder.addCase(loadTOPruefZyklus.fulfilled, (state, action) => {
            state.loadTOPruefZyklusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOPruefZyklusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOPruefZyklusList.push(newItem) }
                else { state.tOPruefZyklusList[i] = { ...state.tOPruefZyklusList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOPruefZyklus.rejected, (state, action) => {
            state.loadTOPruefZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOPruefZyklusError = action.error.message
            } else {
                state.loadTOPruefZyklusError = action.payload
            }
        })

        builder.addCase(saveTOPruefZyklus.pending, (state) => {
            state.saveTOPruefZyklusStatus = 'pending'
            state.saveTOPruefZyklusError = undefined
        })
        builder.addCase(saveTOPruefZyklus.fulfilled, (state, action) => {
            state.saveTOPruefZyklusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOPruefZyklusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOPruefZyklusList.push(newItem) }
                else { state.tOPruefZyklusList[i] = { ...state.tOPruefZyklusList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOPruefZyklus.rejected, (state, action) => {
            state.saveTOPruefZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOPruefZyklusError = action.error.message
            } else {
                state.saveTOPruefZyklusError = action.payload
            }
        })

        builder.addCase(deleteTOPruefZyklus.pending, (state) => {
            state.deleteTOPruefZyklusStatus = 'pending'
            state.deleteTOPruefZyklusError = undefined
        })
        builder.addCase(deleteTOPruefZyklus.fulfilled, (state, action) => {
            state.deleteTOPruefZyklusStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tOPruefZyklusList = state.tOPruefZyklusList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tOPruefZyklusList = state.tOPruefZyklusList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOPruefZyklus.rejected, (state, action) => {
            state.deleteTOPruefZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOPruefZyklusError = action.error.message
            } else {
                state.deleteTOPruefZyklusError = action.payload
            }
        })

    }
})

export const {
    resetloadTOPruefZyklusListError,
    resetloadTOPruefZyklus,
    resetloadTOPruefZyklusError,
    resetsaveTOPruefZyklus,
    resetsaveTOPruefZyklusError,
    resetdeleteTOPruefZyklusError,
    removeFromTOPruefZyklusListById,
    removeFromTOPruefZyklusListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOPruefZyklusSlice.actions
export default TOPruefZyklusSlice.reducer
